import { showPromptDialog } from "aldoo-ra/PromptDialog"
import { showNotification } from "aldoo-ra/Notification"

/**
 * Custom action handler for opening the price editor
 * This is called when user clicks "Edit Price" in the StoreProduct form
 *
 * @param {Object} product - The product being edited
 * @param {Function} save - The save function to trigger product save
 * @returns {Promise<boolean>} - Returns true if should proceed, false if cancelled
 */
export default async function openPriceEditorAction(product, save) {
  // Check if product has been saved
  if (!product._id) {
    const confirmed = await new Promise((resolve) => {
      showPromptDialog({
        title: "Save Product First",
        message: "This product has not been saved yet. Please save the product before adding a price configuration.",
        confirmText: "Save Product",
        cancelText: "Cancel",
        onConfirm: () => resolve(true),
        onCancel: () => resolve(false),
      })
    })

    if (confirmed && save) {
      try {
        // Trigger save - this will save the product and close the dialog
        const saveResult = await save()
        // a save that did not happen (a validation error) is not a success
        if (!saveResult) {
          showNotification({
            message: "The product could not be saved. Fix what is marked, then try again.",
            className: "bg-admin_error text-white",
          })
          return false
        }

        // After save completes, the dialog will close and product data will refresh
        // We return false to prevent opening price editor immediately
        // User will need to reopen the product and then click Edit Price again
        showNotification({
          message: "Product saved successfully. Please click Edit Price again to add pricing.",
          className: "bg-admin_success text-white",
        })
        return false
      } catch (error) {
        showNotification({
          message: "Failed to save product. Please try again.",
          className: "bg-admin_error text-white",
        })
        return false
      }
    }

    // User cancelled or no save function available
    return false
  }

  // Product is saved - proceed
  return true
}
